import { render, staticRenderFns } from "./companySideView.vue?vue&type=template&id=15530356"
import script from "./companySideView.js?vue&type=script&lang=js&external"
export * from "./companySideView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports